import get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import * as BackstageConstants from '../../constants';
import * as D from '../../deps';
import BackstagePlayableRowGrid from '../BackstagePlayableRowGrid';
import BackstagePlayableRowItem from '../BackstagePlayableRowItem';

const CuratedPlaylists = props => {
  const { integration } = useContext(D.AppContext);

  const contentSection = BackstageConstants.BackstageSections.CURATOR_PLAYLISTS;
  const integrationData = { contentSection };

  const onSeeAllPlaylistsClick = e => {
    integration.action.clicked({
      ...integrationData,
      destinationUrl: e.currentTarget.pathname,
    });
  };

  const moreUrl = D.getBackstageAllPlaylistsPathForShareUrl(
    props.shareableUrlPath,
    props.pandoraId,
    props.currentPathname,
  );

  return (
    <CuratedPlaylistsWithLogger
      contentSection={contentSection}
      title={
        props.name ? (
          <FormattedMessage
            {...BackstageConstants.messages.curatorPlaylists}
            values={{ curatorName: props.name }}
          />
        ) : (
          <FormattedMessage {...BackstageConstants.messages.unnamedCuratorPlaylists} />
        )
      }
      onSeeAllClick={onSeeAllPlaylistsClick}
      moreUrl={moreUrl}
      moreText={<FormattedMessage {...BackstageConstants.messages.viewAll} />}
      secondMoreText={
        <FormattedMessage
          {...BackstageConstants.messages.curatorPlaylistsNumber}
          values={{ number: props.numberPlaylists }}
        />
      }
      isFirstSection={props.isFirstSection}
    >
      {props.playlists
        .slice(
          0,
          props.isMobileWeb
            ? BackstageConstants.BackstageConstants.NUM_ITEMS_TO_RENDER_MOBILE_WEB
            : BackstageConstants.BackstageConstants.NUM_CURATOR_STATIONS_TO_RENDER,
        )
        .map((playlist, index) => {
          const pandoraId = get(playlist, 'pandoraId', '');

          return (
            <BackstagePlayableRowItem
              key={pandoraId || index}
              pandoraId={pandoraId}
              itemUrl={get(playlist, 'shareableUrlPath')}
              itemName={get(playlist, 'name', '')}
              pandoraType={D.PandoraTypes.PLAYLIST}
              playIndex={index}
              imgUrl={get(playlist, 'icon.artUrl', '')}
              hasBorderTopBottom={true}
              secondText={
                props.name ? (
                  <FormattedMessage
                    {...BackstageConstants.messages.curatorPlaylistSubtitle}
                    values={{ curatorName: props.name }}
                  />
                ) : (
                  <FormattedMessage
                    {...BackstageConstants.messages.unnamedCuratorPlaylistSubtitle}
                  />
                )
              }
              thirdText={
                <FormattedMessage
                  {...D.Constants.PlaylistT3.messages.songs}
                  values={{ numSongs: get(playlist, 'totalTracks') }}
                />
              }
              secondTextUrl={''}
              dominantColor={get(playlist, 'icon.dominantColor', '')}
            />
          );
        })}
    </CuratedPlaylistsWithLogger>
  );
};

const CuratedPlaylistsWithLogger = D.withVisibilityLogger({
  contentSection: BackstageConstants.BackstageSections.CURATOR_PLAYLISTS,
})(BackstagePlayableRowGrid);

export function mapStateToProps(state) {
  return {
    isMobileWeb: D.isMobileWeb(state),
    currentPathname: D.getCurrentPathnameFromState(state),
  };
}

CuratedPlaylists.propTypes = {
  playlists: PropTypes.array,
  name: PropTypes.string,
  numberPlaylists: PropTypes.number,
  pandoraId: PropTypes.string,
  shareableUrlPath: PropTypes.string,
  isMobileWeb: PropTypes.bool,
  isFirstSection: PropTypes.bool,
  isArtist: PropTypes.bool,
  currentPathname: PropTypes.string,
};

export default connect(mapStateToProps)(CuratedPlaylists);
